import React  from "react";
import { useHistory } from "react-router-dom";
import {
    Card,
    CardBody,
    Button
  } from "reactstrap";

const SearchThankYou = () => {
    const history=useHistory();
const backToSearch=()=>{
    history.push("/searchcandidates");
}
return(
    <>
    <Card className="mt-3 mt-2 w-100 t-card-wid t-rounded-card">
            <CardBody>
              <div>
                <strong>
                  <h1>Thank You !</h1>
                </strong>
              </div>
              <div>The invitation email successfully sent.</div>{" "}
              <Button
                outline
                color="primary"
                className="btn-sm mt-3 ml-0 t-button-search-col btn "
                onClick={() => backToSearch()}
              >
                Back to Search
              </Button>
            </CardBody>
          </Card>
          </>
)

}
export default SearchThankYou;